import { HelpIcon } from './HelpIcon';

/**
 * author: Austin Andrews
 * id 62675A10-D453-40EB-8AED-A789A39EEF11
 * name help
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help.svg
 * tags
 */
export const QuestionMarkIcon = HelpIcon;
export default QuestionMarkIcon